import React from 'react'

import { PlusIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { PermitActionType } from '~/client/graph'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IWorkflowTypeAction } from '~/client/src/shared/models/WorkflowType'

import WorkflowActionConfiguratorStore from '../WorkflowActionConfigurator.store'

interface IProps {
  onAddAction: (action: IWorkflowTypeAction) => void
  store: WorkflowActionConfiguratorStore
}

function AddActionButton(props: IProps) {
  const { onAddAction, store } = props

  const availableActionTypes = Object.values(PermitActionType).filter(type =>
    store.canAddAction(type),
  )

  const hasAvailableActions = availableActionTypes.length > 0

  if (!hasAvailableActions) {
    return null
  }

  const handleAddAction = (actionType: PermitActionType) => {
    onAddAction(store.createNewAction(actionType))
  }

  return (
    <div className="mt10">
      <Popover>
        <PopoverTrigger
          nativeButton={false}
          render={
            <div className="tw:inline-flex tw:items-center text large line-extra-large grey-30 pointer py6 px10 brada24" />
          }
        >
          <PlusIcon className="tw:size-4 tw:shrink-0" />
          <span className="nowrap ml3">
            {Localization.translator.addAction}
          </span>
        </PopoverTrigger>
        <PopoverContent side="bottom" className="tw:w-auto">
          <div className="mb10 text large bold">
            {Localization.translator.selectActionType}:
          </div>
          {availableActionTypes.map(actionType => (
            <div
              key={actionType}
              className="row py10 px16 text large line-extra-large pointer highlighted-hover"
              onClick={() => handleAddAction(actionType)}
            >
              {getActionTypeDisplayName(actionType)}
            </div>
          ))}
        </PopoverContent>
      </Popover>
    </div>
  )
}

function getActionTypeDisplayName(type: PermitActionType): string {
  switch (type) {
    case PermitActionType.StartClosureAction:
      return Localization.translator.closureStart
    case PermitActionType.EndClosureAction:
      return Localization.translator.closureFinish
    default:
      return type
  }
}

export default observer(AddActionButton)
